export default "__VITE_PUBLIC_ASSET__438cb074__"